'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './createaccount.routes';

export class CreateaccountComponent {
  /*@ngInject*/
  constructor(Auth, $state, $scope, $http, theme) {
    this.Auth = Auth;
    this.$state = $state;
    this.$scope = $scope;
    this.$http = $http;
    this.loading = false;
    this.theme = theme;
}

  $onInit(){

        //Load theme functions
        this.theme.initTheme();

    this.$http.get('https://basis.bayareametro.gov/api/organizations')
    .then(response => {
        console.log(response.data);
        this.$scope.jurisdictions = response.data;
    })
    .catch(err => {
        console.log(err);
    })

  
  }
  register(form) {
    this.submitted = true;
    this.loading = true;
    console.log(form);
    if (form.$valid) {
        return this.Auth.createUser({
                First_Name: this.user.First_Name,
                Last_Name: this.user.Last_Name,
                email: this.user.email,
                password: this.user.password,
                Title: this.user.Title,
                Phone: this.user.Phone,
                Organization: this.user.Organization,
                County: this.user.County,
                'app':'hess_app'
            })
            .then(() => {
                // Account created, redirect to home
                // this.$state.go('main');
                this.loading = false;
                this.$state.go('createaccount.success');
                // alert("Success")

            })
            .catch(err => {
                err = err.data;
                this.loading = false;
                this.errors = {};

                // Update validity of form fields that match the sequelize errors
                if (err.name) {
                    angular.forEach(err.fields, (error, field) => {
                        form[field].$setValidity('mongoose', false);
                        this.errors[field] = err.message;
                    });
                }
            });
    }
}
}

export default angular.module('hessApplicationApp.createaccount', [uiRouter])
  .config(routes)
  .component('createaccount', {
    template: require('./createaccount.html'),
    controller: CreateaccountComponent,
    controllerAs: 'createaccountCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/createaccount/createaccount.component.js